export const ngos = [
  {
    id: 1,
    name: "Vidya Kendra",
    location: "Delhi",
    availability: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    topics: ["English", "Maths", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 2,
    name: "Shiksha Setu",
    location: "Mumbai",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Hindi", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
  {
    id: 3,
    name: "Gyan Jyoti",
    location: "Bangalore",
    availability: ["Tuesday", "Thursday", "Saturday"],
    topics: ["Maths", "English"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 4,
    name: "Bhasha Vikas",
    location: "Kolkata",
    availability: ["Monday", "Wednesday", "Saturday", "Sunday"],
    topics: ["Hindi", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
  {
    id: 5,
    name: "Paryavaran Pathshala",
    location: "Chennai",
    availability: ["Monday", "Tuesday", "Wednesday", "Friday", "Saturday"],
    topics: ["EVS", "English"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 6,
    name: "Ganit Gurukul",
    location: "Pune",
    availability: ["Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Maths", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 7,
    name: "Sampark Kendra",
    location: "Delhi",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
  {
    id: 8,
    name: "Vigyan Vidyalaya",
    location: "Mumbai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["EVS", "Maths"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 9,
    name: "Sanskriti Shiksha",
    location: "Bangalore",
    availability: ["Monday", "Wednesday", "Saturday", "Sunday"],
    topics: ["Hindi", "Communication Skills"],
    availabilityTimes: ["3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 10,
    name: "Disha Darshan",
    location: "Kolkata",
    availability: ["Tuesday", "Thursday", "Friday"],
    topics: ["English", "Maths"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
  {
    id: 11,
    name: "Uday Path",
    location: "Chennai",
    availability: ["Monday", "Wednesday", "Saturday", "Sunday"],
    topics: ["EVS", "Communication Skills"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 12,
    name: "Chetna Vikas",
    location: "Pune",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["Hindi", "English"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 13,
    name: "Navodaya Kendra",
    location: "Delhi",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 14,
    name: "Sahyog Shiksha",
    location: "Mumbai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["English", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
  {
    id: 15,
    name: "Pragati Path",
    location: "Bangalore",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 16,
    name: "Asha Kiran",
    location: "Kolkata",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "English"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 17,
    name: "Manav Vikas",
    location: "Chennai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["Communication Skills", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 18,
    name: "Jeevan Jyoti",
    location: "Pune",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Hindi", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM"],
  },
    {
    id: 19,
    name: "Kalpana Kendra",
    location: "Delhi",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["English", "Maths"],
    availabilityTimes: ["3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 20,
    name: "Swayam Shiksha",
    location: "Mumbai",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Communication Skills", "Hindi"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 21,
    name: "Gyan Sarovar",
    location: "Bangalore",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 22,
    name: "Deep Shikha",
    location: "Kolkata",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 23,
    name: "Jyoti Path",
    location: "Chennai",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "Communication Skills"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 24,
    name: "Nirman Kendra",
    location: "Pune",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["EVS", "English"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 25,
    name: "Chetna Kiran",
    location: "Delhi",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 26,
    name: "Prerna Path",
    location: "Mumbai",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["Communication Skills", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 27,
    name: "Navjyoti Kendra",
    location: "Bangalore",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 28,
    name: "Sahara Shiksha",
    location: "Kolkata",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM"],
  },
    {
    id: 29,
    name: "Utsav Shiksha",
    location: "Chennai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Communication Skills", "English"],
    availabilityTimes: ["3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 30,
    name: "Samarth Shiksha",
    location: "Pune",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 31,
    name: "Adarsh Pathshala",
    location: "Delhi",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "Communication Skills"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 32,
    name: "Chetan Path",
    location: "Mumbai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 33,
    name: "Divya Gyan",
    location: "Bangalore",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 34,
    name: "Ekta Shiksha",
    location: "Kolkata",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Communication Skills", "English"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 35,
    name: "Gyan Ganga",
    location: "Chennai",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 36,
    name: "Harit Pathshala",
    location: "Pune",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 37,
    name: "Indradhanush Shiksha",
    location: "Delhi",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 38,
    name: "Jagriti Kendra",
    location: "Mumbai",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM"],
  },
    {
    id: 39,
    name: "Kala Kendra",
    location: "Bangalore",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Communication Skills", "English"],
    availabilityTimes: ["3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 40,
    name: "Lakshya Path",
    location: "Kolkata",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 41,
    name: "Maitri Shiksha",
    location: "Chennai",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "Communication Skills"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 42,
    name: "Nava Chetna",
    location: "Pune",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 43,
    name: "Ojas Path",
    location: "Delhi",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 44,
    name: "Prakash Path",
    location: "Mumbai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Communication Skills", "English"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 45,
    name: "Raj Path",
    location: "Bangalore",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 46,
    name: "Shakti Kendra",
    location: "Kolkata",
    availability: ["Monday", "Wednesday", "Saturday"],
    topics: ["EVS", "Communication Skills"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "3:00 PM - 4:00 PM"],
  },
    {
    id: 47,
    name: "Tarun Path",
    location: "Chennai",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday"],
    topics: ["English", "Hindi"],
    availabilityTimes: ["2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 48,
    name: "Ujjwal Path",
    location: "Pune",
    availability: ["Monday", "Wednesday", "Friday", "Sunday"],
    topics: ["Maths", "EVS"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM"],
  },
    {
    id: 49,
    name: "Vikas Dhara",
    location: "Delhi",
    availability: ["Monday", "Tuesday", "Thursday", "Saturday", "Sunday"],
    topics: ["Communication Skills", "English"],
    availabilityTimes: ["3:00 PM - 4:00 PM", "4:00 PM - 5:00 PM"],
  },
  {
    id: 50,
    name: "Yog Shiksha",
    location: "Mumbai",
    availability: ["Tuesday", "Thursday", "Friday", "Sunday"],
    topics: ["Hindi", "Maths"],
    availabilityTimes: ["1:00 PM - 2:00 PM", "2:00 PM - 3:00 PM", "3:00 PM - 4:00 PM"],
  },
];